import { Badge, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { TowerServiceStatus } from '@/types/device'
import { DEFAULT_TOWER_STATUS } from '../towerStatus'

type TowerStatusBadgeProps = {
  status: TowerServiceStatus | undefined
}

type StatusConfig = {
  color: string
  translationId: string
}

const STATUS_CONFIG: Record<TowerServiceStatus, StatusConfig> = {
  initializing: {
    color: 'gray',
    translationId: 'tower.hardware.status.initializing'
  },
  preparing: {
    color: 'blue',
    translationId: 'vlm.hardware.status.preparing'
  },
  downloading: {
    color: 'blue',
    translationId: 'tower.hardware.status.downloading'
  },
  starting_up: {
    color: 'blue',
    translationId: 'vlm.hardware.status.starting_up'
  },
  running: {
    color: 'green',
    translationId: 'vlm.hardware.status.running'
  },
  degraded: {
    color: 'yellow',
    translationId: 'vlm.hardware.status.degraded'
  },
  stopped: {
    color: 'gray',
    translationId: 'vlm.hardware.status.stopped'
  },
  failed: {
    color: 'red',
    translationId: 'vlm.hardware.status.failed'
  }
}

export const TowerStatusBadge = ({ status }: TowerStatusBadgeProps) => {
  const config = STATUS_CONFIG[status ?? DEFAULT_TOWER_STATUS]

  if (!config) {
    return (
      <Text size="sm" c="dimmed">
        {status}
      </Text>
    )
  }

  return (
    <Badge color={config.color}>
      <FormattedMessage id={config.translationId} />
    </Badge>
  )
}
